import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { Typography } from '@/shared/ui/atoms';
import * as S from './styles';

const DeskTopCategoryGridCard = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const checkImage = `${baseImageUrl}/medicontents/landing/category-check.png`;
  const checkedImage = `${baseImageUrl}/medicontents/landing/category-checked.png`;
  const categoryList = [
    {
      title: '공장 블로그 대형',
      image: `${baseImageUrl}/medicontents/landing/category01.png`,
      list: [
        {
          text: '키워드 중심 반복형 콘텐츠 생산',
          highlightText: ''
        },
        {
          text: '신뢰 낮음',
          highlightText: ''
        },
        {
          text: '의료법 대응 위험',
          highlightText: ''
        },
        {
          text: '낮은 매몰비용',
          highlightText: ''
        },
        {
          text: '방문만하고 이탈',
          highlightText: ''
        }
      ]
    },
    {
      title: '병원 내부작성',
      image: `${baseImageUrl}/medicontents/landing/category02.png`,
      list: [
        {
          text: '전략 없는 콘텐츠',
          highlightText: ''
        },
        {
          text: '전달력 부족',
          highlightText: ''
        },
        {
          text: '의료법 대응 불안정',
          highlightText: ''
        },
        {
          text: '인건비 낭비·시간 낭비',
          highlightText: ''
        },
        {
          text: '검색 노출 안됨',
          highlightText: ''
        }
      ]
    },
    {
      title: '메디컨텐츠',
      image: `${baseImageUrl}/medicontents/landing/category03.png`,
      list: [
        {
          text: '설계 콘텐츠',
          highlightText: '의료 + SEO+ 법률'
        },
        {
          text: '설계',
          highlightText: '환자 공감'
        },
        {
          text: '안전 구조',
          highlightText: '의료법 반영'
        },
        {
          text: '',
          highlightText: '합리적 비용 '
        },
        {
          text: '되는 결과',
          highlightText: '상담으로 연결'
        }
      ]
    }
  ];

  return (
    <motion.div
      initial={{ y: 55, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0 }}
      className={S.motionGrid}
    >
      {categoryList.map((category, index) => {
        const isMedi = index === 2;
        return (
          <div key={`category-grid-${index}`} className={S.column}>
            <div className={`${S.headerBanner} ${isMedi ? S.headerBgMedi : S.headerBgFactory}`}>
              <Typography className={`${S.categoryTitleBadge} ${isMedi ? S.categoryTitleBadgeMedi : S.categoryTitleBadgeFactory}`}>{category.title}</Typography>
              <div className={`${S.headerImageWrap} ${isMedi ? S.headerImageWrapMedi : S.headerImageWrapFactory}`}>
                <Image src={category.image} alt={category.title} fill sizes="100vw" />
              </div>
            </div>
            <ul className={S.list}>
              {category.list.map((item, i) => (
                <li key={`category-grid-${i}`} className={`${S.listItem} ${isMedi ? S.headerBgMedi : S.headerBgFactory}`}>
                  <div className={S.listIcon}>
                    <Image src={isMedi ? checkedImage : checkImage} alt="category-grid-1" fill sizes="100vw" className={S.listIconImg} />
                  </div>
                  <Typography className={`${S.listTypography} ${isMedi ? S.listTypographyMedi : S.listTypographyFactory}`}>
                    <span className={S.highlight}>{item.highlightText}</span>
                    {item.text}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </motion.div>
  );
};

export default DeskTopCategoryGridCard;
